import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=533de25f&"
import script from "./SearchLayout.vue?vue&type=script&lang=ts&"
export * from "./SearchLayout.vue?vue&type=script&lang=ts&"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports